import { render, staticRenderFns } from "./ColorPopover.vue?vue&type=template&id=4b7b3b9c&scoped=true&"
import script from "./ColorPopover.vue?vue&type=script&lang=js&"
export * from "./ColorPopover.vue?vue&type=script&lang=js&"
import style0 from "./ColorPopover.vue?vue&type=style&index=0&id=4b7b3b9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b3b9c",
  null
  
)

export default component.exports